<template>
<div>
  <el-form-item label="Échelle de couleurs" >
    <div v-if="currentScheme && currentScheme.scale" >
      <span class="scheme" >
        <span v-for="i in 100" :style="schemeTick(currentScheme, i)" />
      </span>
      {{ currentScheme.name }}
    </div>
    <el-select
      v-model="scheme"
      :clearable="true"
      placeholder="Échelle de couleurs"
      value-key="name"
      @change="emit" >
      <el-option label="Personnalisé" value="custom" >
        <span class="scheme" >
          <span v-for="i in 100" :style="schemeTick(customScheme, i)" />
        </span>
        Personnalisé
      </el-option>
      <el-option
        v-for="scheme in schemes"
        :key="scheme.name"
        :label="scheme.name"
        :value="scheme" >
        <span class="scheme" >
          <span v-for="i in 100" :style="schemeTick(scheme, i)" />
        </span>
        {{ scheme.name }}
      </el-option>
    </el-select>
    <div v-if="scheme === 'custom'" class="custom-scheme" >
      <div v-for="(color, i) in custom" class="color" >
        <div v-if="i === 0" class="color-label" >
          Couleur de départ:
        </div>
        <div v-else-if="i === custom.length - 1" class="color-label" >
          Couleur d'arrivée:
        </div>
        <div v-else class="color-label" >
          Couleur de transition:
        </div>
        <el-color-picker v-model="custom[i]" @change="emit" />
        <div class="actions" >
          <el-button
            type="primary"
            icon="el-icon-arrow-up"
            :circle="true"
            :disabled="!i"
            size="mini"
            @click="() => { custom.splice(i - 1, 2, custom[i], custom[i - 1]); emit() }" />
          <el-button
            type="primary"
            icon="el-icon-arrow-down"
            :circle="true"
            :disabled="i === custom.length - 1"
            size="mini"
            @click="() => { custom.splice(i, 2, custom[i + 1], custom[i]); emit() }" />
          <el-button
            type="success"
            icon="el-icon-plus"
            :circle="true"
            size="mini"
            @click="() => { custom.splice(i, 0, '#ffffff'); emit() }" />
          <el-button
            type="primary"
            icon="el-icon-close"
            :circle="true"
            :disabled="custom.length < 3"
            size="mini"
            @click="() => { custom.splice(i, 1); emit() }" />
        </div>
      </div>
    </div>
  </el-form-item>
</div>
</template>

<script>
import * as d3Chromatic from 'd3-scale-chromatic'
import * as d3 from 'd3'
import config from './config'

export default {
  props: {
    value: {
      default: null
    }
  },
  watch: {
    value: {
      immediate: true,
      handler (value) {
        if (Array.isArray(value)) {          
          this.scheme = 'custom'
          if (!this.arrayEquals(value, this.custom)) {
            this.custom.splice(0, this.custom.length, ...value)
          }
        } else if (value !== null) {
          this.scheme = this.schemes.find(s => s.name === value)
        } else {
          this.scheme = null
        }
      }
    }
  },
  data () {
    return {
      scheme: null,
      custom: ['#ffff00', '#ffffff', '#0000ff']
    }
  },
  computed: {
    currentScheme () {
      return this.scheme === 'custom' ? this.customScheme : this.scheme
    },
    customScheme () {
      return {
        name: 'Personnalisé',
        scale: d3.scaleSequential(d3.interpolateRgbBasis(this.custom)).domain([0, 100])
      }
    },
    schemes () {
      const d3Schemes = Object
            .keys(d3Chromatic)
            .filter(k => k.startsWith('interpolate'))
            .map(k => {
              return {
                name: k,
                scale: d3.scaleSequential(d3Chromatic[k]).domain([0, 100])
              }
            })
      return config.customSchemes.map(s => {
        return {
          name: s.name,
          scale: s.scale.copy().domain([0, 100])
        }
      }).concat(d3Schemes)
    }
  },
  methods: {
    arrayEquals (a, b) {
      if (a.length !== b.length) {
        return false
      }
      for (let i = 0; i < a.length; ++i) {
        if (a[i] !== b[i]) {
          return false
        }
      }
      return true
    },
    emit () {
      this.$emit('input', this.scheme === 'custom' ? this.custom : (this.scheme ? this.scheme.name : null))
      this.$emit('change')
    },
    schemeTick (scheme, i) {
      return {
        position: 'absolute',
        top: 0,
        bottom: 0,
        width: '1px',
        left: `${i - 1}px`,
        'background-color': scheme.scale(i - 1)
      }
    }
  }
}
</script>

<style scoped>
.scheme {
    width: 100px;
    position: relative;
    height: 1em;
    display: inline-block;
}
.custom-scheme .color {
    display: flex;
}
.custom-scheme .color-label {
    flex: 1;
}
.actions {
    margin-left: 5px;
}
</style>



// WEBPACK FOOTER //
// node_modules/macarons-graphs-front/src/ColorSchemeSelect.vue